export class PinVerifyReq {
    constructor() {
        this.pin = "";
        this.email = "";
        this.tenant = "";
    }
}
